import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  createThis2j2avj17cvnv2 as createThis,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  protoOf180f3jzyo7rfj as protoOf,
  Comparable198qfk8pnblz0 as Comparable,
  KtList3hktaavzmj137 as KtList,
  toSet2orjxp16sotqu as toSet,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  isNaNymqb93xtq8w8 as isNaN_0,
  Unit_instanceat14thlj150z as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  contentEquals379bkuxwxaiqz as contentEquals,
  contentHashCode2dpr73siofp13 as contentHashCode,
  StringBuildermazzzhj6kkai as StringBuilder,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  numberToDouble210hrknaofnhf as numberToDouble,
  coerceIn10f36k81le1mm as coerceIn,
  minOfmf6w75l7u1a7 as minOf,
  maxOf1m19db8qhkqy5 as maxOf,
} from './kotlin-kotlin-stdlib.mjs';
import {
  _Ratio___init__impl__9mwvn2xyj9fjgana63 as _Ratio___init__impl__9mwvn2,
  umod1d8wj61c81r0q as umod,
  isAlmostEquals2e7wogp48cvmj as isAlmostEquals,
  Ratio__toDouble_impl_o7epze2ppsc3gplivz8 as Ratio__toDouble_impl_o7epze,
  toRatio1hooqit5gulhr as toRatio,
  Ratio__times_impl_ucdh7y2x1w5kf040xma as Ratio__times_impl_ucdh7y,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  roundDecimalPlaces1x32iuyd1l8m5 as roundDecimalPlaces,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  isAlmostEquals$default2ib7nwup21mfy as isAlmostEquals$default,
  IsAlmostEquals2vs54x7i426j2 as IsAlmostEquals,
  interpolate2g7wzskc23f1q as interpolate,
  interpolate35pbs3ac913y4 as interpolate_0,
  get_niceStr1tlwtz2l2j4my as get_niceStr_0,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.i2c_1 = Anchor2D.t2c(0.0, 0.0);
    this.j2c_1 = Anchor2D.t2c(0.5, 0.0);
    this.k2c_1 = Anchor2D.t2c(1.0, 0.0);
    this.l2c_1 = Anchor2D.t2c(0.0, 0.5);
    this.m2c_1 = Anchor2D.t2c(0.5, 0.5);
    this.n2c_1 = Anchor2D.t2c(1.0, 0.5);
    this.o2c_1 = Anchor2D.t2c(0.0, 1.0);
    this.p2c_1 = Anchor2D.t2c(0.5, 1.0);
    this.q2c_1 = Anchor2D.t2c(1.0, 1.0);
  }
  u2c() {
    return this.m2c_1;
  }
}
class Anchor2D {
  static v2c(sx, sy) {
    Companion_getInstance();
    var $this = createThis(this);
    $this.r2c_1 = sx;
    $this.s2c_1 = sy;
    return $this;
  }
  static t2c(sx, sy) {
    Companion_getInstance();
    return this.v2c(sx, sy);
  }
  toString() {
    return 'Anchor2D(sx=' + this.r2c_1 + ', sy=' + this.s2c_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.r2c_1);
    result = imul(result, 31) + getNumberHashCode(this.s2c_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Anchor2D))
      return false;
    var tmp0_other_with_cast = other instanceof Anchor2D ? other : THROW_CCE();
    if (!equals(this.r2c_1, tmp0_other_with_cast.r2c_1))
      return false;
    if (!equals(this.s2c_1, tmp0_other_with_cast.s2c_1))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio = toRatio(1.0E-5);
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio, 6.283185307179586);
    tmp.x2c_1 = _Angle___init__impl__g23q1m(tmp$ret$0);
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_0 = toRatio(0.0);
    var tmp$ret$2 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    tmp_0.y2c_1 = _Angle___init__impl__g23q1m(tmp$ret$2);
    var tmp_1 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_1 = toRatio(0.25);
    var tmp$ret$4 = Ratio__times_impl_ucdh7y(ratio_1, 6.283185307179586);
    tmp_1.z2c_1 = _Angle___init__impl__g23q1m(tmp$ret$4);
    var tmp_2 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_2 = toRatio(0.5);
    var tmp$ret$6 = Ratio__times_impl_ucdh7y(ratio_2, 6.283185307179586);
    tmp_2.a2d_1 = _Angle___init__impl__g23q1m(tmp$ret$6);
    var tmp_3 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_3 = toRatio(0.75);
    var tmp$ret$8 = Ratio__times_impl_ucdh7y(ratio_3, 6.283185307179586);
    tmp_3.b2d_1 = _Angle___init__impl__g23q1m(tmp$ret$8);
    var tmp_4 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_4 = toRatio(1.0);
    var tmp$ret$10 = Ratio__times_impl_ucdh7y(ratio_4, 6.283185307179586);
    tmp_4.c2d_1 = _Angle___init__impl__g23q1m(tmp$ret$10);
  }
}
class Angle {
  constructor(radians) {
    Companion_getInstance_0();
    this.w2c_1 = radians;
  }
  d2d(other, epsilon) {
    return Angle__isAlmostEquals_impl_201sgt(this.w2c_1, other, epsilon);
  }
  wz(other, epsilon) {
    return Angle__isAlmostEquals_impl_201sgt_0(this, other, epsilon);
  }
  e2d(other) {
    return Angle__compareTo_impl_a0hfds(this.w2c_1, other);
  }
  d(other) {
    return Angle__compareTo_impl_a0hfds_0(this, other);
  }
  toString() {
    return Angle__toString_impl_786qky(this.w2c_1);
  }
  hashCode() {
    return Angle__hashCode_impl_szcndt(this.w2c_1);
  }
  equals(other) {
    return Angle__equals_impl_zcf5mt(this.w2c_1, other);
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    this.c2e_1 = _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_11().g2e());
  }
  h2e() {
    return this.c2e_1;
  }
  i2e(p1, p2, p3, p4) {
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_11().l2e(Companion_getInstance_17().j2e(p1, p2, p3, p4), Companion_getInstance_17().k2e(p1, p2, p3, p4)));
  }
}
class BoundsBuilder {
  constructor(bounds) {
    Companion_getInstance_1();
    this.u2e_1 = bounds;
  }
  toString() {
    return BoundsBuilder__toString_impl_fmvxh7(this.u2e_1);
  }
  hashCode() {
    return BoundsBuilder__hashCode_impl_649zbo(this.u2e_1);
  }
  equals(other) {
    return BoundsBuilder__equals_impl_jngfjs(this.u2e_1, other);
  }
}
class Companion_2 {}
class Circle {
  constructor(center, radius) {
    this.v2e_1 = center;
    this.w2e_1 = radius;
  }
  x2e() {
    return this.w2e_1 * this.w2e_1;
  }
  y2e(p) {
    return Companion_getInstance_17().z2e(p, this.v2e_1);
  }
  a2f(p) {
    return this.y2e(p) - this.x2e();
  }
  b2f(p) {
    return this.y2e(p) + this.x2e();
  }
  toString() {
    return 'Circle(center=' + this.v2e_1.toString() + ', radius=' + this.w2e_1 + ')';
  }
  hashCode() {
    var result = this.v2e_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.w2e_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Circle))
      return false;
    var tmp0_other_with_cast = other instanceof Circle ? other : THROW_CCE();
    if (!this.v2e_1.equals(tmp0_other_with_cast.v2e_1))
      return false;
    if (!equals(this.w2e_1, tmp0_other_with_cast.w2e_1))
      return false;
    return true;
  }
}
class IPointList$Sublist$listIterator$1 {
  constructor($index, this$0) {
    this.d2f_1 = $index;
    this.e2f_1 = this$0;
    this.c2f_1 = $index;
  }
  b1() {
    return this.c2f_1 >= this.e2f_1.i2f_1;
  }
  c1() {
    var _unary__edvuaz = this.c2f_1;
    this.c2f_1 = _unary__edvuaz + 1 | 0;
    return this.e2f_1.d1(_unary__edvuaz);
  }
}
class Sublist {
  constructor(list, fromIndex, toIndex) {
    this.f2f_1 = list;
    this.g2f_1 = fromIndex;
    this.h2f_1 = toIndex;
    this.i2f_1 = this.h2f_1 - this.g2f_1 | 0;
  }
  e1() {
    return this.i2f_1;
  }
  d1(index) {
    return this.f2f_1.d1(index + this.g2f_1 | 0);
  }
  g1() {
    return this.i2f_1 === 0;
  }
  a1() {
    return this.c3();
  }
  c3() {
    return this.d3(0);
  }
  d3(index) {
    return new IPointList$Sublist$listIterator$1(index, this);
  }
  e3(fromIndex, toIndex) {
    return new Sublist(this.f2f_1, this.g2f_1 + fromIndex | 0, this.g2f_1 + toIndex | 0);
  }
  j2f(element) {
    return Companion_instance_3.k2f(this.f2f_1, element, this.g2f_1, this.h2f_1, -this.g2f_1 | 0);
  }
  b3(element) {
    if (!(element instanceof Vector2D))
      return -1;
    return this.j2f(element instanceof Vector2D ? element : THROW_CCE());
  }
  l2f(elements) {
    return Companion_instance_3.m2f(this, elements);
  }
  a3(elements) {
    return this.l2f(elements);
  }
}
class Companion_3 {
  m2f(_this__u8e3s4, elements) {
    var s = toSet(elements);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(_this__u8e3s4, Collection)) {
        tmp = _this__u8e3s4.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = _this__u8e3s4.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.math.geom.Companion.containsAllSet.<anonymous>' call
        if (!s.z2(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  k2f(list, element, fromIndex, toIndex, offset) {
    var inductionVariable = fromIndex;
    if (inductionVariable < toIndex)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (list.n2f(n) === element.h2d_1 && list.o2f(n) === element.i2d_1)
          return n + offset | 0;
      }
       while (inductionVariable < toIndex);
    return -1;
  }
  p2f(list, element, fromIndex, toIndex, offset, $super) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? list.e1() : toIndex;
    offset = offset === VOID ? 0 : offset;
    return $super === VOID ? this.k2f(list, element, fromIndex, toIndex, offset) : $super.k2f.call(this, list, element, fromIndex, toIndex, offset);
  }
}
class IDoubleVectorList {}
function isNotEmpty() {
  return !(this.e1() === 0);
}
function isAlmostEquals_0(other, epsilon) {
  if (!(this.e1() === other.e1()))
    return false;
  if (!(this.u2f() === other.u2f()))
    return false;
  var inductionVariable = 0;
  var last = this.u2f();
  if (inductionVariable < last)
    do {
      var dim = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = this.e1();
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!isAlmostEquals(this.s2f(n, dim), other.s2f(n, dim), epsilon))
            return false;
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return true;
}
class IPointList {}
function get(index) {
  return Vector2D.q2f(this.n2f(index), this.o2f(index));
}
function containsAll(elements) {
  return Companion_instance_3.m2f(this, elements);
}
function indexOf(element) {
  return Companion_instance_3.p2f(this, element);
}
function iterator() {
  return this.c3();
}
function listIterator() {
  return this.d3(0);
}
function listIterator_0(index) {
  return (new Sublist(this, 0, this.e1())).d3(index);
}
function subList(fromIndex, toIndex) {
  return new Sublist(this, fromIndex, toIndex);
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    this.v2f_1 = Line2D.z2f(Companion_getInstance_17().j2d_1, Companion_getInstance_17().j2d_1);
    this.w2f_1 = Line2D.z2f(Companion_getInstance_17().k2d_1, Companion_getInstance_17().k2d_1);
  }
}
class Line2D {
  static z2f(a, b) {
    Companion_getInstance_4();
    var $this = createThis(this);
    $this.x2f_1 = a;
    $this.y2f_1 = b;
    return $this;
  }
  static a2g() {
    Companion_getInstance_4();
    return this.z2f(Vector2D.b2g(), Vector2D.b2g());
  }
  static c2g(x0, y0, x1, y1) {
    Companion_getInstance_4();
    return this.z2f(Vector2D.d2g(x0, y0), Vector2D.d2g(x1, y1));
  }
  e2g() {
    return this.x2f_1.h2d_1;
  }
  f2g() {
    return this.x2f_1.i2d_1;
  }
  g2g() {
    return this.y2f_1.h2d_1;
  }
  h2g() {
    return this.y2f_1.i2d_1;
  }
  toString() {
    return 'Line(' + this.x2f_1.toString() + ', ' + this.y2f_1.toString() + ')';
  }
  hashCode() {
    var result = this.x2f_1.hashCode();
    result = imul(result, 31) + this.y2f_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Line2D))
      return false;
    var tmp0_other_with_cast = other instanceof Line2D ? other : THROW_CCE();
    if (!this.x2f_1.equals(tmp0_other_with_cast.x2f_1))
      return false;
    if (!this.y2f_1.equals(tmp0_other_with_cast.y2f_1))
      return false;
    return true;
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_5 = this;
    this.i2g_1 = MarginInt.n2g(0, 0, 0, 0);
  }
}
class MarginInt {
  static n2g(top, right, bottom, left) {
    Companion_getInstance_5();
    var $this = createThis(this);
    $this.j2g_1 = top;
    $this.k2g_1 = right;
    $this.l2g_1 = bottom;
    $this.m2g_1 = left;
    return $this;
  }
  static o2g(margin) {
    Companion_getInstance_5();
    return this.n2g(margin, margin, margin, margin);
  }
  p2g() {
    return !(this.j2g_1 === 0) || !(this.m2g_1 === 0) || !(this.k2g_1 === 0) || !(this.l2g_1 === 0);
  }
  q2g() {
    return this.m2g_1 + this.k2g_1 | 0;
  }
  r2g() {
    return this.j2g_1 + this.l2g_1 | 0;
  }
  toString() {
    return 'MarginInt(top=' + this.j2g_1 + ', right=' + this.k2g_1 + ', bottom=' + this.l2g_1 + ', left=' + this.m2g_1 + ')';
  }
  hashCode() {
    var result = this.j2g_1;
    result = imul(result, 31) + this.k2g_1 | 0;
    result = imul(result, 31) + this.l2g_1 | 0;
    result = imul(result, 31) + this.m2g_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MarginInt))
      return false;
    var tmp0_other_with_cast = other instanceof MarginInt ? other : THROW_CCE();
    if (!(this.j2g_1 === tmp0_other_with_cast.j2g_1))
      return false;
    if (!(this.k2g_1 === tmp0_other_with_cast.k2g_1))
      return false;
    if (!(this.l2g_1 === tmp0_other_with_cast.l2g_1))
      return false;
    if (!(this.m2g_1 === tmp0_other_with_cast.m2g_1))
      return false;
    return true;
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_6 = this;
    this.s2g_1 = new Matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
    this.t2g_1 = new Matrix(NaN, NaN, NaN, NaN, NaN, NaN);
    this.u2g_1 = this.t2g_1;
  }
  v2g() {
    return this.s2g_1;
  }
  w2g(a, b, epsilon) {
    return isAlmostEquals(a.b2h_1, b.b2h_1, epsilon) && isAlmostEquals(a.c2h_1, b.c2h_1, epsilon) && isAlmostEquals(a.x2g_1, b.x2g_1, epsilon) && isAlmostEquals(a.y2g_1, b.y2g_1, epsilon) && isAlmostEquals(a.z2g_1, b.z2g_1, epsilon) && isAlmostEquals(a.a2h_1, b.a2h_1, epsilon);
  }
  d2h(l, r) {
    if (l.w2d())
      return r;
    if (r.w2d())
      return l;
    return new Matrix(l.x2g_1 * r.x2g_1 + l.y2g_1 * r.z2g_1, l.x2g_1 * r.y2g_1 + l.y2g_1 * r.a2h_1, l.z2g_1 * r.x2g_1 + l.a2h_1 * r.z2g_1, l.z2g_1 * r.y2g_1 + l.a2h_1 * r.a2h_1, l.b2h_1 * r.x2g_1 + l.c2h_1 * r.z2g_1 + r.b2h_1, l.b2h_1 * r.y2g_1 + l.c2h_1 * r.a2h_1 + r.c2h_1);
  }
  e2h(x, y, rotation, scaleX, scaleY, skewX, skewY, pivotX, pivotY) {
    // Inline function 'korlibs.math.geom.cos' call
    var angle = Angle__plus_impl_26v37k(rotation, skewY);
    var up = Companion_getInstance_17().n2d_1;
    var a = Angle__cosine_impl_bgvzun(angle, up) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_0 = Angle__plus_impl_26v37k(rotation, skewY);
    var up_0 = Companion_getInstance_17().n2d_1;
    var b = Angle__sine_impl_3l11xv(angle_0, up_0) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_1 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_1 = Companion_getInstance_17().n2d_1;
    var c = -Angle__sine_impl_3l11xv(angle_1, up_1) * scaleY + 0.0;
    // Inline function 'korlibs.math.geom.cos' call
    var angle_2 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_2 = Companion_getInstance_17().n2d_1;
    var d = Angle__cosine_impl_bgvzun(angle_2, up_2) * scaleY + 0.0;
    var tx;
    var ty;
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = x;
      ty = y;
    } else {
      tx = x - (pivotX * a + pivotY * c);
      ty = y - (pivotX * b + pivotY * d);
    }
    return new Matrix(a, b, c, d, tx, ty);
  }
  f2h(a, b, c, d, tx, ty, p) {
    return Vector2D.q2f(a * p.h2d_1 + c * p.i2d_1 + tx, d * p.i2d_1 + b * p.h2d_1 + ty);
  }
}
class Matrix {
  constructor(a, b, c, d, tx, ty) {
    Companion_getInstance_6();
    tx = tx === VOID ? 0.0 : tx;
    ty = ty === VOID ? 0.0 : ty;
    this.x2g_1 = a;
    this.y2g_1 = b;
    this.z2g_1 = c;
    this.a2h_1 = d;
    this.b2h_1 = tx;
    this.c2h_1 = ty;
  }
  g2h(other) {
    return Companion_getInstance_6().d2h(this, other);
  }
  w2d() {
    return isNaN_0(this.x2g_1);
  }
  x2d() {
    return !this.w2d();
  }
  h2h() {
    return this.x2g_1 === 1.0 && this.y2g_1 === 0.0 && this.z2g_1 === 0.0 && this.a2h_1 === 1.0 && this.b2h_1 === 0.0 && this.c2h_1 === 0.0;
  }
  i2h() {
    var hasRotation = !(this.y2g_1 === 0.0) || !(this.z2g_1 === 0.0);
    var hasScale = !(this.x2g_1 === 1.0) || !(this.a2h_1 === 1.0);
    var hasTranslation = !(this.b2h_1 === 0.0) || !(this.c2h_1 === 0.0);
    return hasRotation ? MatrixType_COMPLEX_getInstance() : hasScale && hasTranslation ? MatrixType_SCALE_TRANSLATE_getInstance() : hasScale ? MatrixType_SCALE_getInstance() : hasTranslation ? MatrixType_TRANSLATE_getInstance() : MatrixType_IDENTITY_getInstance();
  }
  j2h(p) {
    return this.k2h(p.h2d_1, p.i2d_1);
  }
  l2h(x, y) {
    return this.k2h(x, y);
  }
  m2h(x, y) {
    return this.n2h(x, y);
  }
  k2h(x, y) {
    return this.x2g_1 * x + this.z2g_1 * y + this.b2h_1;
  }
  n2h(x, y) {
    return this.a2h_1 * y + this.y2g_1 * x + this.c2h_1;
  }
  o2h(x, y) {
    return this.k2h(x, y);
  }
  p2h(x, y) {
    return this.n2h(x, y);
  }
  q2h(angle) {
    // Inline function 'korlibs.math.geom.cos' call
    var up = Companion_getInstance_17().n2d_1;
    var cos = Angle__cosine_impl_bgvzun(angle, up);
    // Inline function 'korlibs.math.geom.sin' call
    var up_0 = Companion_getInstance_17().n2d_1;
    var sin = Angle__sine_impl_3l11xv(angle, up_0);
    var a1 = this.x2g_1 * cos - this.y2g_1 * sin;
    var b = this.x2g_1 * sin + this.y2g_1 * cos;
    var a = a1;
    var c1 = this.z2g_1 * cos - this.a2h_1 * sin;
    var d = this.z2g_1 * sin + this.a2h_1 * cos;
    var c = c1;
    var tx1 = this.b2h_1 * cos - this.c2h_1 * sin;
    var ty = this.b2h_1 * sin + this.c2h_1 * cos;
    var tx = tx1;
    return new Matrix(a, b, c, d, tx, ty);
  }
  r2h(scaleX, scaleY) {
    return this.s2h(scaleX, scaleY);
  }
  s2h(scaleX, scaleY) {
    return new Matrix(this.x2g_1 * scaleX, this.y2g_1 * scaleX, this.z2g_1 * scaleY, this.a2h_1 * scaleY, this.b2h_1 * scaleX, this.c2h_1 * scaleY);
  }
  t2h(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.s2h(scaleX, scaleY) : $super.s2h.call(this, scaleX, scaleY);
  }
  u2h(scaleX, scaleY) {
    return new Matrix(this.x2g_1 * scaleX, this.y2g_1 * scaleX, this.z2g_1 * scaleY, this.a2h_1 * scaleY, this.b2h_1, this.c2h_1);
  }
  v2h(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.u2h(scaleX, scaleY) : $super.u2h.call(this, scaleX, scaleY);
  }
  w2h(delta) {
    return new Matrix(this.x2g_1, this.y2g_1, this.z2g_1, this.a2h_1, this.b2h_1 + delta.h2d_1, this.c2h_1 + delta.i2d_1);
  }
  x2h(x, y) {
    return this.w2h(Vector2D.d2g(x, y));
  }
  y2h(x, y) {
    return this.w2h(Vector2D.q2f(x, y));
  }
  z2h(delta) {
    return new Matrix(this.x2g_1, this.y2g_1, this.z2g_1, this.a2h_1, this.b2h_1 + (this.x2g_1 * delta.h2d_1 + this.z2g_1 * delta.i2d_1), this.c2h_1 + (this.y2g_1 * delta.h2d_1 + this.a2h_1 * delta.i2d_1));
  }
  a2i(deltaX, deltaY) {
    return this.z2h(Vector2D.b2i(deltaX, deltaY));
  }
  c2i(deltaX, deltaY) {
    return this.z2h(Vector2D.q2f(deltaX, deltaY));
  }
  d2i(m) {
    return m.g2h(this);
  }
  o10() {
    return this;
  }
  e2i() {
    if (this.w2d())
      return Companion_getInstance_6().s2g_1;
    var m = this;
    var norm = m.x2g_1 * m.a2h_1 - m.y2g_1 * m.z2g_1;
    var tmp;
    if (norm === 0.0) {
      tmp = new Matrix(0.0, 0.0, 0.0, 0.0, -m.b2h_1, -m.c2h_1);
    } else {
      var inorm = 1.0 / norm;
      var d = m.x2g_1 * inorm;
      var a = m.a2h_1 * inorm;
      var b = m.y2g_1 * -inorm;
      var c = m.z2g_1 * -inorm;
      tmp = new Matrix(a, b, c, d, -a * m.b2h_1 - c * m.c2h_1, -b * m.b2h_1 - d * m.c2h_1);
    }
    return tmp;
  }
  f2i() {
    return this.g2i();
  }
  g2i() {
    return Companion_getInstance_7().i2i(this);
  }
  toString() {
    return 'Matrix(' + get_niceStr(this.x2g_1) + ', ' + get_niceStr(this.y2g_1) + ', ' + get_niceStr(this.z2g_1) + ', ' + get_niceStr(this.a2h_1) + ', ' + get_niceStr(this.b2h_1) + ', ' + get_niceStr(this.c2h_1) + ')';
  }
  j2i(other, epsilon) {
    return Companion_getInstance_6().w2g(this, other, epsilon);
  }
  wz(other, epsilon) {
    return this.j2i(other instanceof Matrix ? other : THROW_CCE(), epsilon);
  }
  k2i(other) {
    return this.g2h(other);
  }
  hashCode() {
    var result = getNumberHashCode(this.x2g_1);
    result = imul(result, 31) + getNumberHashCode(this.y2g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z2g_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a2h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b2h_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c2h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Matrix))
      return false;
    var tmp0_other_with_cast = other instanceof Matrix ? other : THROW_CCE();
    if (!equals(this.x2g_1, tmp0_other_with_cast.x2g_1))
      return false;
    if (!equals(this.y2g_1, tmp0_other_with_cast.y2g_1))
      return false;
    if (!equals(this.z2g_1, tmp0_other_with_cast.z2g_1))
      return false;
    if (!equals(this.a2h_1, tmp0_other_with_cast.a2h_1))
      return false;
    if (!equals(this.b2h_1, tmp0_other_with_cast.b2h_1))
      return false;
    if (!equals(this.c2h_1, tmp0_other_with_cast.c2h_1))
      return false;
    return true;
  }
}
class MatrixType extends Enum {
  constructor(name, ordinal, id, hasRotation, hasScale, hasTranslation) {
    super(name, ordinal);
    this.n2i_1 = id;
    this.o2i_1 = hasRotation;
    this.p2i_1 = hasScale;
    this.q2i_1 = hasTranslation;
  }
}
class Companion_7 {
  constructor() {
    Companion_instance_7 = this;
    this.h2i_1 = MatrixTransform.y2i(0.0, 0.0, 1.0, 1.0, Companion_getInstance_0().y2c_1, Companion_getInstance_0().y2c_1, Companion_getInstance_0().y2c_1);
  }
  z2i(matrix, pivotX, pivotY) {
    var a = matrix.x2g_1;
    var b = matrix.y2g_1;
    var c = matrix.z2g_1;
    var d = matrix.a2h_1;
    // Inline function 'kotlin.math.atan2' call
    var y = -c;
    var skewX = -Math.atan2(y, d);
    // Inline function 'kotlin.math.atan2' call
    var skewY = Math.atan2(b, a);
    // Inline function 'kotlin.math.abs' call
    var x = skewX + skewY;
    var delta = Math.abs(x);
    var trotation;
    var tskewX;
    var tskewY;
    var tx;
    var ty;
    var tmp;
    if (delta < 0.001) {
      tmp = true;
    } else {
      // Inline function 'kotlin.math.abs' call
      var x_0 = 3.141592653589793 * 2 - delta;
      tmp = Math.abs(x_0) < 0.001;
    }
    if (tmp) {
      trotation = get_radians_0(skewY);
      tskewX = get_radians_0(0.0);
      tskewY = get_radians_0(0.0);
    } else {
      trotation = get_radians(0);
      tskewX = get_radians_0(skewX);
      tskewY = get_radians_0(skewY);
    }
    // Inline function 'kotlin.math.hypot' call
    var tscaleX = hypot(a, b);
    // Inline function 'kotlin.math.hypot' call
    var tscaleY = hypot(c, d);
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = matrix.b2h_1;
      ty = matrix.c2h_1;
    } else {
      tx = matrix.b2h_1 + (pivotX * a + pivotY * c);
      ty = matrix.c2h_1 + (pivotX * b + pivotY * d);
    }
    return MatrixTransform.y2i(tx, ty, tscaleX, tscaleY, tskewX, tskewY, trotation);
  }
  i2i(matrix, pivotX, pivotY, $super) {
    pivotX = pivotX === VOID ? 0.0 : pivotX;
    pivotY = pivotY === VOID ? 0.0 : pivotY;
    return $super === VOID ? this.z2i(matrix, pivotX, pivotY) : $super.z2i.call(this, matrix, pivotX, pivotY);
  }
  a2j(a, b, epsilon) {
    return isAlmostEquals(a.r2i_1, b.r2i_1, epsilon) && isAlmostEquals(a.s2i_1, b.s2i_1, epsilon) && isAlmostEquals(a.t2i_1, b.t2i_1, epsilon) && isAlmostEquals(a.u2i_1, b.u2i_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.v2i_1, b.v2i_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.w2i_1, b.w2i_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.x2i_1, b.x2i_1, epsilon);
  }
}
class MatrixTransform {
  static y2i(x, y, scaleX, scaleY, skewX, skewY, rotation) {
    Companion_getInstance_7();
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    scaleX = scaleX === VOID ? 1.0 : scaleX;
    scaleY = scaleY === VOID ? 1.0 : scaleY;
    skewX = skewX === VOID ? Companion_getInstance_0().y2c_1 : skewX;
    skewY = skewY === VOID ? Companion_getInstance_0().y2c_1 : skewY;
    rotation = rotation === VOID ? Companion_getInstance_0().y2c_1 : rotation;
    var $this = createThis(this);
    $this.r2i_1 = x;
    $this.s2i_1 = y;
    $this.t2i_1 = scaleX;
    $this.u2i_1 = scaleY;
    $this.v2i_1 = skewX;
    $this.w2i_1 = skewY;
    $this.x2i_1 = rotation;
    return $this;
  }
  toString() {
    return 'MatrixTransform(x=' + get_niceStr(this.r2i_1) + ', y=' + get_niceStr(this.s2i_1) + ', scaleX=' + this.t2i_1 + ', scaleY=' + this.u2i_1 + ', skewX=' + Angle__toString_impl_786qky(this.v2i_1) + ', skewY=' + Angle__toString_impl_786qky(this.w2i_1) + ', rotation=' + Angle__toString_impl_786qky(this.x2i_1) + ')';
  }
  static b2j() {
    Companion_getInstance_7();
    return this.y2i(0.0, 0.0, 1.0, 1.0, Companion_getInstance_0().y2c_1, Companion_getInstance_0().y2c_1, Companion_getInstance_0().y2c_1);
  }
  c2j(other, epsilon) {
    return Companion_getInstance_7().a2j(this, other, epsilon);
  }
  wz(other, epsilon) {
    return this.c2j(other instanceof MatrixTransform ? other : THROW_CCE(), epsilon);
  }
  d2j() {
    return (this.t2i_1 + this.u2i_1) * 0.5;
  }
  hashCode() {
    var result = getNumberHashCode(this.r2i_1);
    result = imul(result, 31) + getNumberHashCode(this.s2i_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t2i_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u2i_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.v2i_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.w2i_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.x2i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MatrixTransform))
      return false;
    var tmp0_other_with_cast = other instanceof MatrixTransform ? other : THROW_CCE();
    if (!equals(this.r2i_1, tmp0_other_with_cast.r2i_1))
      return false;
    if (!equals(this.s2i_1, tmp0_other_with_cast.s2i_1))
      return false;
    if (!equals(this.t2i_1, tmp0_other_with_cast.t2i_1))
      return false;
    if (!equals(this.u2i_1, tmp0_other_with_cast.u2i_1))
      return false;
    if (!equals(this.v2i_1, tmp0_other_with_cast.v2i_1))
      return false;
    if (!equals(this.w2i_1, tmp0_other_with_cast.w2i_1))
      return false;
    if (!equals(this.x2i_1, tmp0_other_with_cast.x2i_1))
      return false;
    return true;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_8 = this;
    this.e2j_1 = 0;
    this.f2j_1 = 1;
    this.g2j_1 = 2;
    this.h2j_1 = 3;
    this.i2j_1 = 4;
    this.j2j_1 = 5;
    this.k2j_1 = 6;
    this.l2j_1 = 7;
    this.m2j_1 = 8;
    this.n2j_1 = 9;
    this.o2j_1 = 10;
    this.p2j_1 = 11;
    this.q2j_1 = 12;
    this.r2j_1 = 13;
    this.s2j_1 = 14;
    this.t2j_1 = 15;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp.u2j_1 = new Int32Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
    var tmp_0 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_0.v2j_1 = new Int32Array([0, 4, 8, 12, 1, 5, 9, 13, 2, 6, 10, 14, 3, 7, 11, 15]);
    var tmp_1 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_1.w2j_1 = new Int32Array([0, 1, 2, 4, 5, 6, 8, 9, 10]);
    var tmp_2 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_2.x2j_1 = new Int32Array([0, 4, 8, 1, 5, 9, 2, 6, 10]);
    this.y2j_1 = Matrix4.a2k();
  }
  b2k(v00, v01, v02, v03, v10, v11, v12, v13, v20, v21, v22, v23, v30, v31, v32, v33) {
    return Matrix4.c2k(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33);
  }
  d2k(l, r) {
    return Companion_getInstance_8().b2k(l.e2k() * r.e2k() + l.f2k() * r.g2k() + l.h2k() * r.i2k() + l.j2k() * r.k2k(), l.e2k() * r.f2k() + l.f2k() * r.l2k() + l.h2k() * r.m2k() + l.j2k() * r.n2k(), l.e2k() * r.h2k() + l.f2k() * r.o2k() + l.h2k() * r.p2k() + l.j2k() * r.q2k(), l.e2k() * r.j2k() + l.f2k() * r.r2k() + l.h2k() * r.s2k() + l.j2k() * r.t2k(), l.g2k() * r.e2k() + l.l2k() * r.g2k() + l.o2k() * r.i2k() + l.r2k() * r.k2k(), l.g2k() * r.f2k() + l.l2k() * r.l2k() + l.o2k() * r.m2k() + l.r2k() * r.n2k(), l.g2k() * r.h2k() + l.l2k() * r.o2k() + l.o2k() * r.p2k() + l.r2k() * r.q2k(), l.g2k() * r.j2k() + l.l2k() * r.r2k() + l.o2k() * r.s2k() + l.r2k() * r.t2k(), l.i2k() * r.e2k() + l.m2k() * r.g2k() + l.p2k() * r.i2k() + l.s2k() * r.k2k(), l.i2k() * r.f2k() + l.m2k() * r.l2k() + l.p2k() * r.m2k() + l.s2k() * r.n2k(), l.i2k() * r.h2k() + l.m2k() * r.o2k() + l.p2k() * r.p2k() + l.s2k() * r.q2k(), l.i2k() * r.j2k() + l.m2k() * r.r2k() + l.p2k() * r.s2k() + l.s2k() * r.t2k(), l.k2k() * r.e2k() + l.n2k() * r.g2k() + l.q2k() * r.i2k() + l.t2k() * r.k2k(), l.k2k() * r.f2k() + l.n2k() * r.l2k() + l.q2k() * r.m2k() + l.t2k() * r.n2k(), l.k2k() * r.h2k() + l.n2k() * r.o2k() + l.q2k() * r.p2k() + l.t2k() * r.q2k(), l.k2k() * r.j2k() + l.n2k() * r.r2k() + l.q2k() * r.s2k() + l.t2k() * r.t2k());
  }
  u2k(left, right, bottom, top, near, far) {
    var sx = 2.0 / (right - left);
    var sy = 2.0 / (top - bottom);
    var sz = -2.0 / (far - near);
    var tx = -(right + left) / (right - left);
    var ty = -(top + bottom) / (top - bottom);
    var tz = -(far + near) / (far - near);
    return Companion_getInstance_8().b2k(sx, 0.0, 0.0, tx, 0.0, sy, 0.0, ty, 0.0, 0.0, sz, tz, 0.0, 0.0, 0.0, 1.0);
  }
  v2k(left, right, bottom, top, near, far) {
    return this.u2k(left, right, bottom, top, near, far);
  }
}
class Matrix4 {
  static w2k(data) {
    Companion_getInstance_8();
    var $this = createThis(this);
    $this.z2j_1 = data;
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!($this.z2j_1.length === 16)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.l5(toString(message));
    }
    return $this;
  }
  e2k() {
    return this.z2j_1[0];
  }
  g2k() {
    return this.z2j_1[1];
  }
  i2k() {
    return this.z2j_1[2];
  }
  k2k() {
    return this.z2j_1[3];
  }
  f2k() {
    return this.z2j_1[4];
  }
  l2k() {
    return this.z2j_1[5];
  }
  m2k() {
    return this.z2j_1[6];
  }
  n2k() {
    return this.z2j_1[7];
  }
  h2k() {
    return this.z2j_1[8];
  }
  o2k() {
    return this.z2j_1[9];
  }
  p2k() {
    return this.z2j_1[10];
  }
  q2k() {
    return this.z2j_1[11];
  }
  j2k() {
    return this.z2j_1[12];
  }
  r2k() {
    return this.z2j_1[13];
  }
  s2k() {
    return this.z2j_1[14];
  }
  t2k() {
    return this.z2j_1[15];
  }
  equals(other) {
    var tmp;
    if (other instanceof Matrix4) {
      tmp = contentEquals(this.z2j_1, other.z2j_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode(this.z2j_1);
  }
  x2k(that) {
    return Companion_getInstance_8().d2k(this, that);
  }
  static c2k(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33) {
    Companion_getInstance_8();
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$0 = new Float32Array([v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33]);
    return this.w2k(tmp$ret$0);
  }
  static a2k() {
    Companion_getInstance_8();
    return this.c2k(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
  }
  s2f(row, column) {
    if (!(0 <= column ? column <= 3 : false) || !(0 <= row ? row <= 3 : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + row + ',' + column;
      throw IllegalStateException.l5(toString(message));
    }
    return this.z2j_1[imul(row, 4) + column | 0];
  }
  y2k(index) {
    if (!(0 <= index ? index <= (this.z2j_1.length - 1 | 0) : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + index;
      throw IllegalStateException.l5(toString(message));
    }
    return this.z2j_1[index];
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.Matrix4.toString.<anonymous>' call
    this_0.ec('Matrix4(\n');
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var row = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0.ec('  [ ');
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var col = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!(col === 0)) {
              this_0.ec(', ');
            }
            var v = this.s2f(row, col);
            // Inline function 'kotlin.math.floor' call
            if (Math.floor(v) === v)
              this_0.gh(numberToInt(v));
            else {
              this_0.ih(v);
            }
          }
           while (inductionVariable_0 < 4);
        this_0.ec(' ],\n');
      }
       while (inductionVariable < 4);
    this_0.ec(')');
    return this_0.toString();
  }
}
class Companion_9 {
  constructor() {
    this.f2d_1 = 1.0E-7;
  }
  g2d(up) {
    // Inline function 'kotlin.check' call
    var tmp;
    if (up.h2d_1 === 0.0) {
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = up.i2d_1;
      tmp = Math.abs(this_0) === 1.0;
    } else {
      tmp = false;
    }
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp) {
      // Inline function 'korlibs.math.geom.Companion.checkValidUpVector.<anonymous>' call
      var message = 'up vector only supports (0, -1) and (0, +1) for now';
      throw IllegalStateException.l5(toString(message));
    }
  }
}
class Orientation extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.e2l_1 = value;
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_10 = this;
    var tmp = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_10();
    tmp.f2l_1 = new RectCorners(numberToDouble(0), numberToDouble(0), numberToDouble(0), numberToDouble(0));
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_10();
    tmp_0.g2l_1 = new RectCorners(numberToDouble(0), numberToDouble(0), numberToDouble(0), numberToDouble(0));
    var tmp_1 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_10();
    tmp_1.h2l_1 = new RectCorners(numberToDouble(1.0), numberToDouble(1.0), numberToDouble(1.0), numberToDouble(1.0));
    var tmp_2 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_10();
    var corner = -1.0;
    tmp_2.i2l_1 = new RectCorners(numberToDouble(corner), numberToDouble(corner), numberToDouble(corner), numberToDouble(corner));
    var tmp_3 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_10();
    tmp_3.j2l_1 = new RectCorners(numberToDouble(NaN), numberToDouble(NaN), numberToDouble(NaN), numberToDouble(NaN));
  }
}
class RectCorners {
  constructor(topLeft, topRight, bottomRight, bottomLeft) {
    Companion_getInstance_10();
    this.k2l_1 = topLeft;
    this.l2l_1 = topRight;
    this.m2l_1 = bottomRight;
    this.n2l_1 = bottomLeft;
  }
  toString() {
    return 'RectCorners(topLeft=' + this.k2l_1 + ', topRight=' + this.l2l_1 + ', bottomRight=' + this.m2l_1 + ', bottomLeft=' + this.n2l_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.k2l_1);
    result = imul(result, 31) + getNumberHashCode(this.l2l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m2l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n2l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectCorners))
      return false;
    var tmp0_other_with_cast = other instanceof RectCorners ? other : THROW_CCE();
    if (!equals(this.k2l_1, tmp0_other_with_cast.k2l_1))
      return false;
    if (!equals(this.l2l_1, tmp0_other_with_cast.l2l_1))
      return false;
    if (!equals(this.m2l_1, tmp0_other_with_cast.m2l_1))
      return false;
    if (!equals(this.n2l_1, tmp0_other_with_cast.n2l_1))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_11 = this;
    this.d2e_1 = Companion_getInstance_11().o2l(0, 0, 0, 0);
    this.e2e_1 = Companion_getInstance_11().p2l(-Infinity, -Infinity, Infinity, Infinity);
    this.f2e_1 = Companion_getInstance_11().p2l(NaN, NaN, 0.0, 0.0);
  }
  g2e() {
    return this.f2e_1;
  }
  v2g() {
    return this.d2e_1;
  }
  p2e(p, s) {
    return new Rectangle(p.h2d_1, p.i2d_1, s.m2e_1, s.n2e_1);
  }
  o2l(x, y, width, height) {
    return Companion_getInstance_11().p2e(Vector2D.d2g(x, y), Size2D.o2e(width, height));
  }
  p2l(x, y, width, height) {
    return Companion_getInstance_11().p2e(Vector2D.b2i(x, y), Size2D.q2l(width, height));
  }
  r2l(left, top, right, bottom) {
    return new Rectangle(left, top, right - left, bottom - top);
  }
  s2l(left, top, right, bottom) {
    return this.r2l(left, top, right, bottom);
  }
  l2e(point1, point2) {
    var tmp = Companion_getInstance_11();
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var tmp$ret$0 = Vector2D.q2f(point2.h2d_1 - point1.h2d_1, point2.i2d_1 - point1.i2d_1);
    return tmp.p2e(point1, toSize(tmp$ret$0));
  }
  t2l(a, b) {
    return a.r2d_1 >= b.r2d_1 && a.s2d_1 >= b.s2d_1 && a.r2d_1 + a.t2d_1 <= b.r2d_1 + b.t2d_1 && a.s2d_1 + a.u2d_1 <= b.s2d_1 + b.u2d_1;
  }
}
class Rectangle {
  constructor(x, y, width, height) {
    Companion_getInstance_11();
    this.r2d_1 = x;
    this.s2d_1 = y;
    this.t2d_1 = width;
    this.u2d_1 = height;
    this.v2d_1 = true;
  }
  o10() {
    return this;
  }
  e1() {
    return Size2D.u2l(this.t2d_1, this.u2d_1);
  }
  v2l() {
    return isNaN_0(this.r2d_1);
  }
  w2d() {
    return this.v2l();
  }
  x2d() {
    return !this.w2d();
  }
  w2l(other, epsilon) {
    return isAlmostEquals(this.r2d_1, other.r2d_1, epsilon) && isAlmostEquals(this.s2d_1, other.s2d_1, epsilon) && isAlmostEquals(this.t2d_1, other.t2d_1, epsilon) && isAlmostEquals(this.u2d_1, other.u2d_1, epsilon);
  }
  wz(other, epsilon) {
    return this.w2l(other instanceof Rectangle ? other : THROW_CCE(), epsilon);
  }
  toString() {
    return this.w2d() ? 'null' : 'Rectangle(x=' + get_niceStr(this.r2d_1) + ', y=' + get_niceStr(this.s2d_1) + ', width=' + get_niceStr(this.t2d_1) + ', height=' + get_niceStr(this.u2d_1) + ')';
  }
  x2l(scale) {
    return new Rectangle(this.r2d_1 * scale, this.s2d_1 * scale, this.t2d_1 * scale, this.u2d_1 * scale);
  }
  y2l(that) {
    return this.z2l(that.h2d_1, that.i2d_1);
  }
  z2l(x, y) {
    return x >= this.y2d() && x < this.z2d() && (y >= this.a2e() && y < this.b2e());
  }
  y2d() {
    return this.r2d_1;
  }
  a2e() {
    return this.s2d_1;
  }
  z2d() {
    return this.r2d_1 + this.t2d_1;
  }
  b2e() {
    return this.s2d_1 + this.u2d_1;
  }
  q2e() {
    return Vector2D.q2f(this.y2d(), this.a2e());
  }
  a2m() {
    return Vector2D.q2f(this.z2d(), this.a2e());
  }
  b2m() {
    return Vector2D.q2f(this.y2d(), this.b2e());
  }
  s2e() {
    return Vector2D.q2f(this.z2d(), this.b2e());
  }
  c2m() {
    return (this.z2d() + this.y2d()) * 0.5;
  }
  d2m() {
    return (this.b2e() + this.a2e()) * 0.5;
  }
  e2m() {
    return Vector2D.q2f(this.c2m(), this.d2m());
  }
  f2m(that) {
    return this.g2m(that) && this.h2m(that);
  }
  g2m(that) {
    return that.y2d() <= this.z2d() && that.z2d() >= this.y2d();
  }
  h2m(that) {
    return that.a2e() <= this.b2e() && that.b2e() >= this.a2e();
  }
  i2m(that) {
    var tmp;
    if (this.f2m(that)) {
      // Inline function 'kotlin.math.max' call
      var a = this.y2d();
      var b = that.y2d();
      var tmp_0 = Math.max(a, b);
      // Inline function 'kotlin.math.max' call
      var a_0 = this.a2e();
      var b_0 = that.a2e();
      var tmp_1 = Math.max(a_0, b_0);
      // Inline function 'kotlin.math.min' call
      var a_1 = this.z2d();
      var b_1 = that.z2d();
      var tmp_2 = Math.min(a_1, b_1);
      // Inline function 'kotlin.math.min' call
      var a_2 = this.b2e();
      var b_2 = that.b2e();
      var tmp$ret$3 = Math.min(a_2, b_2);
      tmp = new Rectangle(tmp_0, tmp_1, tmp_2, tmp$ret$3);
    } else {
      tmp = Companion_getInstance_11().g2e();
    }
    return tmp;
  }
  l2() {
    return RectangleInt.n2m(numberToInt(this.r2d_1), numberToInt(this.s2d_1), numberToInt(this.t2d_1), numberToInt(this.u2d_1));
  }
  o2m(border) {
    return Companion_getInstance_11().r2l(this.y2d() - border.m2g_1, this.a2e() - border.j2g_1, this.z2d() + border.k2g_1, this.b2e() + border.l2g_1);
  }
  w2h(delta) {
    return this.p2m(this.r2d_1 + delta.h2d_1, this.s2d_1 + delta.i2d_1);
  }
  q2m(m) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = this.q2e();
      if (m.w2d()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.q2f(m.k2h(p.h2d_1, p.i2d_1), m.n2h(p.h2d_1, p.i2d_1));
    }
    var tl = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_0 = this.a2m();
      if (m.w2d()) {
        tmp$ret$1 = p_0;
        break $l$block_0;
      }
      tmp$ret$1 = Vector2D.q2f(m.k2h(p_0.h2d_1, p_0.i2d_1), m.n2h(p_0.h2d_1, p_0.i2d_1));
    }
    var tr = tmp$ret$1;
    var tmp$ret$2;
    $l$block_1: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_1 = this.b2m();
      if (m.w2d()) {
        tmp$ret$2 = p_1;
        break $l$block_1;
      }
      tmp$ret$2 = Vector2D.q2f(m.k2h(p_1.h2d_1, p_1.i2d_1), m.n2h(p_1.h2d_1, p_1.i2d_1));
    }
    var bl = tmp$ret$2;
    var tmp$ret$3;
    $l$block_2: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_2 = this.s2e();
      if (m.w2d()) {
        tmp$ret$3 = p_2;
        break $l$block_2;
      }
      tmp$ret$3 = Vector2D.q2f(m.k2h(p_2.h2d_1, p_2.i2d_1), m.n2h(p_2.h2d_1, p_2.i2d_1));
    }
    var br = tmp$ret$3;
    var min = Companion_getInstance_17().j2e(tl, tr, bl, br);
    var max = Companion_getInstance_17().k2e(tl, tr, bl, br);
    return Companion_getInstance_11().l2e(min, max);
  }
  r2m() {
    return Companion_getInstance_11().l2e(Companion_getInstance_17().r2e(this.q2e(), this.s2e()), Companion_getInstance_17().t2e(this.q2e(), this.s2e()));
  }
  s2m(x, y, width, height) {
    return new Rectangle(x, y, width, height);
  }
  p2m(x, y, width, height, $super) {
    x = x === VOID ? this.r2d_1 : x;
    y = y === VOID ? this.s2d_1 : y;
    width = width === VOID ? this.t2d_1 : width;
    height = height === VOID ? this.u2d_1 : height;
    return $super === VOID ? this.s2m(x, y, width, height) : $super.s2m.call(this, x, y, width, height);
  }
  hashCode() {
    var result = getNumberHashCode(this.r2d_1);
    result = imul(result, 31) + getNumberHashCode(this.s2d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t2d_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u2d_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Rectangle))
      return false;
    var tmp0_other_with_cast = other instanceof Rectangle ? other : THROW_CCE();
    if (!equals(this.r2d_1, tmp0_other_with_cast.r2d_1))
      return false;
    if (!equals(this.s2d_1, tmp0_other_with_cast.s2d_1))
      return false;
    if (!equals(this.t2d_1, tmp0_other_with_cast.t2d_1))
      return false;
    if (!equals(this.u2d_1, tmp0_other_with_cast.u2d_1))
      return false;
    return true;
  }
}
class Companion_12 {
  u2m(a, b) {
    // Inline function 'kotlin.math.min' call
    var a_0 = a.y2d();
    var b_0 = b.y2d();
    var tmp = Math.min(a_0, b_0);
    // Inline function 'kotlin.math.min' call
    var a_1 = a.a2e();
    var b_1 = b.a2e();
    var tmp_0 = Math.min(a_1, b_1);
    // Inline function 'kotlin.math.max' call
    var a_2 = a.z2d();
    var b_2 = b.z2d();
    var tmp_1 = Math.max(a_2, b_2);
    // Inline function 'kotlin.math.max' call
    var a_3 = a.b2e();
    var b_3 = b.b2e();
    var tmp$ret$3 = Math.max(a_3, b_3);
    return this.s2l(tmp, tmp_0, tmp_1, tmp$ret$3);
  }
  v2m(topLeft, bottomRight) {
    var size = bottomRight.y2m(topLeft);
    return RectangleInt.n2m(topLeft.w2m_1, topLeft.x2m_1, size.w2m_1, size.x2m_1);
  }
  s2l(left, top, right, bottom) {
    return this.v2m(Vector2I.z2m(left, top), Vector2I.z2m(right, bottom));
  }
}
class RectangleInt {
  static n2m(x, y, width, height) {
    var $this = createThis(this);
    $this.j2m_1 = x;
    $this.k2m_1 = y;
    $this.l2m_1 = width;
    $this.m2m_1 = height;
    return $this;
  }
  static a2n() {
    return this.n2m(0, 0, 0, 0);
  }
  b2n() {
    return imul(this.l2m_1, this.m2m_1);
  }
  y2d() {
    return this.j2m_1;
  }
  a2e() {
    return this.k2m_1;
  }
  z2d() {
    return this.j2m_1 + this.l2m_1 | 0;
  }
  b2e() {
    return this.k2m_1 + this.m2m_1 | 0;
  }
  c2n(left, top, right, bottom, clamped) {
    var left_0 = !clamped ? left : coerceIn(left, 0, this.l2m_1);
    var right_0 = !clamped ? right : coerceIn(right, 0, this.l2m_1);
    var top_0 = !clamped ? top : coerceIn(top, 0, this.m2m_1);
    var bottom_0 = !clamped ? bottom : coerceIn(bottom, 0, this.m2m_1);
    return Companion_instance_12.s2l(this.j2m_1 + left_0 | 0, this.k2m_1 + top_0 | 0, this.j2m_1 + right_0 | 0, this.k2m_1 + bottom_0 | 0);
  }
  toString() {
    return 'Rectangle(x=' + this.j2m_1 + ', y=' + this.k2m_1 + ', width=' + this.l2m_1 + ', height=' + this.m2m_1 + ')';
  }
  d2n() {
    return Companion_getInstance_11().o2l(this.j2m_1, this.k2m_1, this.l2m_1, this.m2m_1);
  }
  o2m(border) {
    return Companion_instance_12.s2l(this.y2d() - border.m2g_1 | 0, this.a2e() - border.j2g_1 | 0, this.z2d() + border.k2g_1 | 0, this.b2e() + border.l2g_1 | 0);
  }
  hashCode() {
    var result = this.j2m_1;
    result = imul(result, 31) + this.k2m_1 | 0;
    result = imul(result, 31) + this.l2m_1 | 0;
    result = imul(result, 31) + this.m2m_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectangleInt))
      return false;
    var tmp0_other_with_cast = other instanceof RectangleInt ? other : THROW_CCE();
    if (!(this.j2m_1 === tmp0_other_with_cast.j2m_1))
      return false;
    if (!(this.k2m_1 === tmp0_other_with_cast.k2m_1))
      return false;
    if (!(this.l2m_1 === tmp0_other_with_cast.l2m_1))
      return false;
    if (!(this.m2m_1 === tmp0_other_with_cast.m2m_1))
      return false;
    return true;
  }
}
class Companion_13 {}
class RoundRectangle {
  constructor(rect, corners) {
    this.e2n_1 = rect;
    this.f2n_1 = corners;
  }
  toString() {
    return 'RoundRectangle(rect=' + this.e2n_1.toString() + ', corners=' + this.f2n_1.toString() + ')';
  }
  hashCode() {
    var result = this.e2n_1.hashCode();
    result = imul(result, 31) + this.f2n_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RoundRectangle))
      return false;
    var tmp0_other_with_cast = other instanceof RoundRectangle ? other : THROW_CCE();
    if (!this.e2n_1.equals(tmp0_other_with_cast.e2n_1))
      return false;
    if (!this.f2n_1.equals(tmp0_other_with_cast.f2n_1))
      return false;
    return true;
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_14 = this;
    this.g2n_1 = Scale.h2n(1.0, 1.0);
  }
}
class Scale {
  static b2l(scaleX, scaleY) {
    Companion_getInstance_14();
    var $this = createThis(this);
    $this.z2k_1 = scaleX;
    $this.a2l_1 = scaleY;
    return $this;
  }
  d2j() {
    return this.z2k_1 * 0.5 + this.a2l_1 * 0.5;
  }
  static i2n() {
    Companion_getInstance_14();
    return this.h2n(1.0, 1.0);
  }
  static j2n(scale) {
    Companion_getInstance_14();
    return this.b2l(scale, scale);
  }
  static k2n(scale) {
    Companion_getInstance_14();
    return this.j2n(scale);
  }
  static h2n(scaleX, scaleY) {
    Companion_getInstance_14();
    return this.b2l(scaleX, scaleY);
  }
  static l2n(scaleX, scaleY) {
    Companion_getInstance_14();
    return this.b2l(scaleX, scaleY);
  }
  toString() {
    return 'Scale(scaleX=' + this.z2k_1 + ', scaleY=' + this.a2l_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.z2k_1);
    result = imul(result, 31) + getNumberHashCode(this.a2l_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Scale))
      return false;
    var tmp0_other_with_cast = other instanceof Scale ? other : THROW_CCE();
    if (!equals(this.z2k_1, tmp0_other_with_cast.z2k_1))
      return false;
    if (!equals(this.a2l_1, tmp0_other_with_cast.a2l_1))
      return false;
    return true;
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_15 = this;
    var tmp = this;
    tmp.p2n_1 = new ScaleMode('COVER', ScaleMode$Companion$COVER$lambda);
    var tmp_0 = this;
    tmp_0.q2n_1 = new ScaleMode('SHOW_ALL', ScaleMode$Companion$SHOW_ALL$lambda);
    var tmp_1 = this;
    tmp_1.r2n_1 = new ScaleMode('EXACT', ScaleMode$Companion$EXACT$lambda);
    var tmp_2 = this;
    tmp_2.s2n_1 = new ScaleMode('NO_SCALE', ScaleMode$Companion$NO_SCALE$lambda);
  }
  t2n() {
    return this.r2n_1;
  }
}
class ScaleMode {
  constructor(name, transform) {
    Companion_getInstance_15();
    name = name === VOID ? null : name;
    this.u2n_1 = name;
    this.v2n_1 = transform;
  }
  toString() {
    return 'ScaleMode(' + this.u2n_1 + ')';
  }
  w2n(item, container) {
    return toInt(this.v2n_1(toFloat(item), toFloat(container)));
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_16 = this;
    this.x2n_1 = Size2D.u2l(0.0, 0.0);
  }
}
class Size2D {
  static u2l(width, height) {
    Companion_getInstance_16();
    var $this = createThis(this);
    $this.m2e_1 = width;
    $this.n2e_1 = height;
    return $this;
  }
  static y2n() {
    Companion_getInstance_16();
    return this.u2l(0.0, 0.0);
  }
  static q2l(width, height) {
    Companion_getInstance_16();
    return this.u2l(width, height);
  }
  static o2e(width, height) {
    Companion_getInstance_16();
    return this.u2l(width, height);
  }
  z2n(scale) {
    return Size2D.u2l(this.m2e_1 * scale.z2k_1, this.n2e_1 * scale.a2l_1);
  }
  a2o(s) {
    return Size2D.u2l(this.m2e_1 * s, this.n2e_1 * s);
  }
  x2l(s) {
    return this.a2o(s);
  }
  m2n(other) {
    return Scale.b2l(this.m2e_1 / other.m2e_1, this.n2e_1 / other.n2e_1);
  }
  toString() {
    return 'Size(width=' + get_niceStr(this.m2e_1) + ', height=' + get_niceStr(this.n2e_1) + ')';
  }
  ul() {
    return this.m2e_1;
  }
  vl() {
    return this.n2e_1;
  }
  hashCode() {
    var result = getNumberHashCode(this.m2e_1);
    result = imul(result, 31) + getNumberHashCode(this.n2e_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Size2D))
      return false;
    var tmp0_other_with_cast = other instanceof Size2D ? other : THROW_CCE();
    if (!equals(this.m2e_1, tmp0_other_with_cast.m2e_1))
      return false;
    if (!equals(this.n2e_1, tmp0_other_with_cast.n2e_1))
      return false;
    return true;
  }
}
class SizeInt {
  static d2o(width, height) {
    var $this = createThis(this);
    $this.b2o_1 = width;
    $this.c2o_1 = height;
    return $this;
  }
  static e2o() {
    return this.d2o(0, 0);
  }
  toString() {
    return '' + this.b2o_1 + 'x' + this.c2o_1;
  }
  hashCode() {
    var result = this.b2o_1;
    result = imul(result, 31) + this.c2o_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SizeInt))
      return false;
    var tmp0_other_with_cast = other instanceof SizeInt ? other : THROW_CCE();
    if (!(this.b2o_1 === tmp0_other_with_cast.b2o_1))
      return false;
    if (!(this.c2o_1 === tmp0_other_with_cast.c2o_1))
      return false;
    return true;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_17 = this;
    this.j2d_1 = Vector2D.q2f(0.0, 0.0);
    this.k2d_1 = Vector2D.q2f(NaN, NaN);
    this.l2d_1 = Vector2D.q2f(-1.0, 0.0);
    this.m2d_1 = Vector2D.q2f(+1.0, 0.0);
    this.n2d_1 = Vector2D.q2f(0.0, +1.0);
    this.o2d_1 = Vector2D.q2f(0.0, -1.0);
    this.p2d_1 = Vector2D.q2f(0.0, -1.0);
    this.q2d_1 = Vector2D.q2f(0.0, +1.0);
  }
  f2o(a, b, up) {
    // Inline function 'korlibs.math.geom.Companion.between' call
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var x0 = a.h2d_1;
    var y0 = a.i2d_1;
    var x1 = b.h2d_1;
    var y1 = b.i2d_1;
    return Angle_between(x0, y0, x1, y1, up);
  }
  g2o(a, b, up, $super) {
    up = up === VOID ? this.n2d_1 : up;
    return $super === VOID ? this.f2o(a, b, up) : $super.f2o.call(this, a, b, up).w2c_1;
  }
  h2o(a, b, up) {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    // Inline function 'kotlin.math.acos' call
    var x = a.i2o(b) / (a.a() * b.a());
    var radians = Math.acos(x);
    var tmp$ret$1 = _Angle___init__impl__g23q1m(radians);
    return adjustFromUp(tmp$ret$1, up);
  }
  j2o(a, b, up, $super) {
    up = up === VOID ? this.n2d_1 : up;
    return $super === VOID ? this.h2o(a, b, up) : $super.h2o.call(this, a, b, up).w2c_1;
  }
  t2m(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  k2o(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  l2o(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  m2o(a, b) {
    return this.t2m(a.h2d_1, a.i2d_1, b.h2d_1, b.i2d_1);
  }
  z2e(a, b) {
    return this.n2o(a.h2d_1, a.i2d_1, b.h2d_1, b.i2d_1);
  }
  n2o(x1, y1, x2, y2) {
    return square(this, x1 - x2) + square(this, y1 - y2);
  }
  o2o(ax, ay, bx, by) {
    return ax * by - bx * ay;
  }
  p2o(p1, p2) {
    return this.o2o(p1.h2d_1, p1.i2d_1, p2.h2d_1, p2.i2d_1);
  }
  r2e(p1, p2) {
    // Inline function 'kotlin.math.min' call
    var a = p1.h2d_1;
    var b = p2.h2d_1;
    var tmp = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = p1.i2d_1;
    var b_0 = p2.i2d_1;
    var tmp$ret$1 = Math.min(a_0, b_0);
    return Vector2D.q2f(tmp, tmp$ret$1);
  }
  j2e(p1, p2, p3, p4) {
    return Vector2D.q2f(minOf(p1.h2d_1, new Float64Array([p2.h2d_1, p3.h2d_1, p4.h2d_1])), minOf(p1.i2d_1, new Float64Array([p2.i2d_1, p3.i2d_1, p4.i2d_1])));
  }
  t2e(p1, p2) {
    // Inline function 'kotlin.math.max' call
    var a = p1.h2d_1;
    var b = p2.h2d_1;
    var tmp = Math.max(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = p1.i2d_1;
    var b_0 = p2.i2d_1;
    var tmp$ret$1 = Math.max(a_0, b_0);
    return Vector2D.q2f(tmp, tmp$ret$1);
  }
  k2e(p1, p2, p3, p4) {
    return Vector2D.q2f(maxOf(p1.h2d_1, new Float64Array([p2.h2d_1, p3.h2d_1, p4.h2d_1])), maxOf(p1.i2d_1, new Float64Array([p2.i2d_1, p3.i2d_1, p4.i2d_1])));
  }
}
class Vector2D {
  static q2f(x, y) {
    Companion_getInstance_17();
    var $this = createThis(this);
    $this.h2d_1 = x;
    $this.i2d_1 = y;
    return $this;
  }
  static b2i(x, y) {
    Companion_getInstance_17();
    return this.q2f(x, y);
  }
  static d2g(x, y) {
    Companion_getInstance_17();
    return this.q2f(x, y);
  }
  static b2g() {
    Companion_getInstance_17();
    return this.q2f(0.0, 0.0);
  }
  o2n() {
    // Inline function 'kotlin.math.min' call
    var a = this.h2d_1;
    var b = this.i2d_1;
    return Math.min(a, b);
  }
  n2n() {
    // Inline function 'kotlin.math.max' call
    var a = this.h2d_1;
    var b = this.i2d_1;
    return Math.max(a, b);
  }
  q2o(x, y) {
    // Inline function 'kotlin.math.hypot' call
    var x_0 = x - this.h2d_1;
    var y_0 = y - this.i2d_1;
    return hypot(x_0, y_0);
  }
  r2o(that) {
    return this.q2o(that.h2d_1, that.i2d_1);
  }
  i2o(that) {
    return this.h2d_1 * that.h2d_1 + this.i2d_1 * that.i2d_1;
  }
  a() {
    // Inline function 'kotlin.math.hypot' call
    var x = this.h2d_1;
    var y = this.i2d_1;
    return hypot(x, y);
  }
  s2o() {
    var x = this.h2d_1;
    var y = this.i2d_1;
    return x * x + y * y;
  }
  t2o() {
    // Inline function 'kotlin.math.hypot' call
    var x = this.h2d_1;
    var y = this.i2d_1;
    return hypot(x, y);
  }
  u2o() {
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale = 1.0 / this.t2o();
    return Vector2D.q2f(this.h2d_1 * scale, this.i2d_1 * scale);
  }
  v2o() {
    // Inline function 'korlibs.math.geom.Vector2D.div' call
    var scale = this.a();
    return Vector2D.q2f(this.h2d_1 / scale, this.i2d_1 / scale);
  }
  w2o() {
    return Vector2D.q2f(-this.i2d_1, this.h2d_1);
  }
  x2o(other, epsilon) {
    return isAlmostEquals(this.h2d_1, other.h2d_1, epsilon) && isAlmostEquals(this.i2d_1, other.i2d_1, epsilon);
  }
  wz(other, epsilon) {
    return this.x2o(other instanceof Vector2D ? other : THROW_CCE(), epsilon);
  }
  y2o() {
    return '(' + get_niceStr(this.h2d_1) + ', ' + get_niceStr(this.i2d_1) + ')';
  }
  toString() {
    return this.y2o();
  }
  ul() {
    return this.h2d_1;
  }
  vl() {
    return this.i2d_1;
  }
  hashCode() {
    var result = getNumberHashCode(this.h2d_1);
    result = imul(result, 31) + getNumberHashCode(this.i2d_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2D))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2D ? other : THROW_CCE();
    if (!equals(this.h2d_1, tmp0_other_with_cast.h2d_1))
      return false;
    if (!equals(this.i2d_1, tmp0_other_with_cast.i2d_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_18 = this;
    this.z2o_1 = new Vector4F(0.0, 0.0, 0.0, 0.0);
    this.a2p_1 = new Vector4F(1.0, 1.0, 1.0, 1.0);
  }
}
class Vector4F {
  constructor(x, y, z, w) {
    Companion_getInstance_18();
    this.b2p_1 = x;
    this.c2p_1 = y;
    this.d2p_1 = z;
    this.e2p_1 = w;
  }
  toString() {
    return 'Vector4(' + get_niceStr_0(this.b2p_1) + ', ' + get_niceStr_0(this.c2p_1) + ', ' + get_niceStr_0(this.d2p_1) + ', ' + get_niceStr_0(this.e2p_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.b2p_1);
    result = imul(result, 31) + getNumberHashCode(this.c2p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d2p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e2p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector4F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector4F ? other : THROW_CCE();
    if (!equals(this.b2p_1, tmp0_other_with_cast.b2p_1))
      return false;
    if (!equals(this.c2p_1, tmp0_other_with_cast.c2p_1))
      return false;
    if (!equals(this.d2p_1, tmp0_other_with_cast.d2p_1))
      return false;
    if (!equals(this.e2p_1, tmp0_other_with_cast.e2p_1))
      return false;
    return true;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_19 = this;
    this.f2p_1 = new Vector3F(NaN, NaN, NaN);
    this.g2p_1 = new Vector3F(0.0, 0.0, 0.0);
    this.h2p_1 = new Vector3F(1.0, 1.0, 1.0);
    this.i2p_1 = new Vector3F(0.0, 0.0, 1.0);
    this.j2p_1 = new Vector3F(0.0, 0.0, -1.0);
    this.k2p_1 = new Vector3F(-1.0, 0.0, 0.0);
    this.l2p_1 = new Vector3F(1.0, 0.0, 0.0);
    this.m2p_1 = new Vector3F(0.0, 1.0, 0.0);
    this.n2p_1 = new Vector3F(0.0, -1.0, 0.0);
  }
}
class Vector3F {
  constructor(x, y, z) {
    Companion_getInstance_19();
    this.o2p_1 = x;
    this.p2p_1 = y;
    this.q2p_1 = z;
  }
  r2p(other) {
    var dx = this.o2p_1 - other.o2p_1;
    var dy = this.p2p_1 - other.p2p_1;
    var dz = this.q2p_1 - other.q2p_1;
    // Inline function 'kotlin.math.sqrt' call
    var x = dx * dx + dy * dy + dz * dz;
    return Math.sqrt(x);
  }
  toString() {
    return 'Vector3(' + get_niceStr_0(this.o2p_1) + ', ' + get_niceStr_0(this.p2p_1) + ', ' + get_niceStr_0(this.q2p_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.o2p_1);
    result = imul(result, 31) + getNumberHashCode(this.p2p_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q2p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector3F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector3F ? other : THROW_CCE();
    if (!equals(this.o2p_1, tmp0_other_with_cast.o2p_1))
      return false;
    if (!equals(this.p2p_1, tmp0_other_with_cast.p2p_1))
      return false;
    if (!equals(this.q2p_1, tmp0_other_with_cast.q2p_1))
      return false;
    return true;
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_20 = this;
    this.s2p_1 = Vector2I.z2m(0, 0);
  }
}
class Vector2I {
  static z2m(x, y) {
    Companion_getInstance_20();
    var $this = createThis(this);
    $this.w2m_1 = x;
    $this.x2m_1 = y;
    return $this;
  }
  static t2p() {
    Companion_getInstance_20();
    return this.z2m(0, 0);
  }
  y2m(that) {
    return Vector2I.z2m(this.w2m_1 - that.w2m_1 | 0, this.x2m_1 - that.x2m_1 | 0);
  }
  toString() {
    return '(' + this.w2m_1 + ', ' + this.x2m_1 + ')';
  }
  hashCode() {
    var result = this.w2m_1;
    result = imul(result, 31) + this.x2m_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2I))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2I ? other : THROW_CCE();
    if (!(this.w2m_1 === tmp0_other_with_cast.w2m_1))
      return false;
    if (!(this.x2m_1 === tmp0_other_with_cast.x2m_1))
      return false;
    return true;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function _Angle___init__impl__g23q1m(radians) {
  return radians;
}
function _Angle___get_radians__impl__n00yt5($this) {
  return $this;
}
function _Angle___get_ratio__impl__ap3on4($this) {
  // Inline function 'korlibs.math.geom.Companion.radiansToRatio' call
  Companion_getInstance_0();
  var radians = _Angle___get_radians__impl__n00yt5($this);
  return _Ratio___init__impl__9mwvn2(radians / 6.283185307179586);
}
function _Angle___get_degrees__impl__qg56vw($this) {
  // Inline function 'korlibs.math.geom.Companion.radiansToDegrees' call
  Companion_getInstance_0();
  return _Angle___get_radians__impl__n00yt5($this) * 57.29577951308232;
}
function _Angle___get_cosine__impl__vprvmu($this) {
  // Inline function 'kotlin.math.cos' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.cos(x);
}
function _Angle___get_sine__impl__15nmyi($this) {
  // Inline function 'kotlin.math.sin' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.sin(x);
}
function _Angle___get_tangent__impl__vushdy($this) {
  // Inline function 'kotlin.math.tan' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.tan(x);
}
function Angle__cosine_impl_bgvzun($this, up) {
  return _Angle___get_cosine__impl__vprvmu(adjustFromUp($this, up));
}
function Angle__sine_impl_3l11xv($this, up) {
  return _Angle___get_sine__impl__15nmyi(adjustFromUp($this, up));
}
function _Angle___get_absoluteValue__impl__4qoakv($this) {
  // Inline function 'kotlin.math.absoluteValue' call
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var this_0 = _Angle___get_radians__impl__n00yt5($this);
  var tmp$ret$1 = Math.abs(this_0);
  return _Angle___init__impl__g23q1m(tmp$ret$1);
}
function Angle__times_impl_v3s9y2($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 * scale);
}
function Angle__div_impl_ut2btd($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 / scale);
}
function Angle__times_impl_v3s9y2_0($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 * scale);
}
function Angle__umod_impl_4wilf7($this, angle) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(angle);
  return _Angle___init__impl__g23q1m(umod(tmp, tmp$ret$1));
}
function Angle__div_impl_ut2btd_0($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  return tmp / _Angle___get_radians__impl__n00yt5(other);
}
function Angle__plus_impl_26v37k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp + tmp$ret$1);
}
function Angle__minus_impl_xeau7k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp - tmp$ret$1);
}
function Angle__unaryMinus_impl_7901fr($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(-tmp$ret$0);
}
function Angle__unaryPlus_impl_eyi5pl($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(+tmp$ret$0);
}
function Angle__isAlmostEquals_impl_201sgt($this, other, epsilon) {
  return isAlmostEquals(_Angle___get_radians__impl__n00yt5($this), _Angle___get_radians__impl__n00yt5(other), epsilon);
}
function Angle__isAlmostEquals_impl_201sgt_0($this, other, epsilon) {
  return Angle__isAlmostEquals_impl_201sgt($this.w2c_1, other instanceof Angle ? other.w2c_1 : THROW_CCE(), epsilon);
}
function _Angle___get_normalized__impl__9s30ys($this) {
  // Inline function 'korlibs.math.geom.Companion.fromRatio' call
  Companion_getInstance_0();
  var ratio = umod(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4($this)), 1.0);
  // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
  var ratio_0 = toRatio(ratio);
  var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function Angle__compareTo_impl_a0hfds($this, other) {
  return Ratio__compareTo_impl_z2ienc(_Angle___get_ratio__impl__ap3on4($this), _Angle___get_ratio__impl__ap3on4(other));
}
function Angle__compareTo_impl_a0hfds_0($this, other) {
  return Angle__compareTo_impl_a0hfds($this.w2c_1, other instanceof Angle ? other.w2c_1 : THROW_CCE());
}
function Angle__toString_impl_786qky($this) {
  return get_niceStr(roundDecimalPlaces(_Angle___get_degrees__impl__qg56vw($this), 2)) + '.degrees';
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function Angle__hashCode_impl_szcndt($this) {
  return getNumberHashCode($this);
}
function Angle__equals_impl_zcf5mt($this, other) {
  if (!(other instanceof Angle))
    return false;
  var tmp0_other_with_cast = other instanceof Angle ? other.w2c_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function get_degrees(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromDegrees' call
  // Inline function 'korlibs.math.geom.Companion.degreesToRadians' call
  Companion_getInstance_0();
  var tmp$ret$0 = _this__u8e3s4 * 0.017453292519943295;
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function get_radians(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_0();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function interpolateAngleDenormalized(_this__u8e3s4, l, r) {
  return interpolateAngle(_this__u8e3s4, l, r, false);
}
function get_radians_0(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_0();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function get_degrees_0(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromDegrees' call
  // Inline function 'korlibs.math.geom.Companion.degreesToRadians' call
  Companion_getInstance_0();
  var tmp$ret$0 = _this__u8e3s4 * 0.017453292519943295;
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function adjustFromUp(_this__u8e3s4, up) {
  Companion_instance_9.g2d(up);
  return up.i2d_1 > 0 ? _this__u8e3s4 : Angle__unaryMinus_impl_7901fr(_this__u8e3s4);
}
function Angle_between(x0, y0, x1, y1, up) {
  up = up === VOID ? Companion_getInstance_17().n2d_1 : up;
  // Inline function 'korlibs.math.geom.Companion.atan2' call
  Companion_getInstance_0();
  var x = y1 - y0;
  var y = x1 - x0;
  var up_0 = Companion_getInstance_17().n2d_1;
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  // Inline function 'kotlin.math.atan2' call
  var radians = Math.atan2(x, y);
  var tmp$ret$1 = _Angle___init__impl__g23q1m(radians);
  var angle = adjustFromUp(tmp$ret$1, up_0);
  return adjustFromUp(Angle__compareTo_impl_a0hfds(angle, Companion_getInstance_0().y2c_1) < 0 ? Angle__plus_impl_26v37k(angle, Companion_getInstance_0().c2d_1) : angle, up);
}
function interpolateAngle(_this__u8e3s4, l, r, minimizeAngle) {
  return _interpolateAngleAny(_this__u8e3s4, l, r, minimizeAngle);
}
function _interpolateAngleAny(ratio, l, r, minimizeAngle) {
  minimizeAngle = minimizeAngle === VOID ? true : minimizeAngle;
  if (!minimizeAngle) {
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_0();
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = interpolate(ratio, _Angle___get_ratio__impl__ap3on4(l), _Angle___get_ratio__impl__ap3on4(r));
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    return _Angle___init__impl__g23q1m(tmp$ret$0);
  }
  var ln = _Angle___get_normalized__impl__9s30ys(l);
  var rn = _Angle___get_normalized__impl__9s30ys(r);
  var tmp;
  if (Angle__compareTo_impl_a0hfds(_Angle___get_absoluteValue__impl__4qoakv(Angle__minus_impl_xeau7k(rn, ln)), Companion_getInstance_0().a2d_1) <= 0) {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(ln), _Angle___get_radians__impl__n00yt5(rn));
    tmp = _Angle___init__impl__g23q1m(radians);
  } else if (Angle__compareTo_impl_a0hfds(ln, rn) < 0) {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians_0 = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(Angle__plus_impl_26v37k(ln, Companion_getInstance_0().c2d_1)), _Angle___get_radians__impl__n00yt5(rn));
    var tmp$ret$3 = _Angle___init__impl__g23q1m(radians_0);
    tmp = _Angle___get_normalized__impl__9s30ys(tmp$ret$3);
  } else {
    // Inline function 'korlibs.math.geom.Companion.fromRadians' call
    Companion_getInstance_0();
    var radians_1 = interpolate_0(ratio, _Angle___get_radians__impl__n00yt5(ln), _Angle___get_radians__impl__n00yt5(Angle__plus_impl_26v37k(rn, Companion_getInstance_0().c2d_1)));
    var tmp$ret$4 = _Angle___init__impl__g23q1m(radians_1);
    tmp = _Angle___get_normalized__impl__9s30ys(tmp$ret$4);
  }
  return tmp;
}
function _BoundsBuilder___init__impl__g6dprh(bounds) {
  return bounds;
}
function _BoundsBuilder___get_bounds__impl__s1l1gx($this) {
  return $this;
}
function _BoundsBuilder___get_isEmpty__impl__e9t785($this) {
  return _BoundsBuilder___get_bounds__impl__s1l1gx($this).w2d();
}
function _BoundsBuilder___get_isNotEmpty__impl__w6rbsy($this) {
  return _BoundsBuilder___get_bounds__impl__s1l1gx($this).x2d();
}
function _BoundsBuilder___get_xmin__impl__o2sib0($this) {
  // Inline function 'kotlin.math.min' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).y2d();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).z2d();
  return Math.min(a, b);
}
function _BoundsBuilder___get_xmax__impl__gsz0km($this) {
  // Inline function 'kotlin.math.max' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).y2d();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).z2d();
  return Math.max(a, b);
}
function _BoundsBuilder___get_ymin__impl__5n2e8j($this) {
  // Inline function 'kotlin.math.min' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).a2e();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).b2e();
  return Math.min(a, b);
}
function _BoundsBuilder___get_ymax__impl__oia4uz($this) {
  // Inline function 'kotlin.math.max' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).a2e();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).b2e();
  return Math.max(a, b);
}
function BoundsBuilder__xminOr_impl_k3l1m2($this, default_0) {
  return _BoundsBuilder___get_hasPoints__impl__6mwi9x($this) ? _BoundsBuilder___get_xmin__impl__o2sib0($this) : default_0;
}
function _BoundsBuilder___get_hasPoints__impl__6mwi9x($this) {
  return _BoundsBuilder___get_isNotEmpty__impl__w6rbsy($this);
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function BoundsBuilder__plus_impl_cz7f7x($this, p) {
  if (_BoundsBuilder___get_bounds__impl__s1l1gx($this).w2d())
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_11().p2e(p, Size2D.o2e(0, 0)));
  return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_11().l2e(Companion_getInstance_17().r2e(_BoundsBuilder___get_bounds__impl__s1l1gx($this).q2e(), p), Companion_getInstance_17().t2e(_BoundsBuilder___get_bounds__impl__s1l1gx($this).s2e(), p)));
}
function BoundsBuilder__plus_impl_cz7f7x_0($this, rect) {
  if (rect == null)
    return $this;
  if (rect.w2d())
    return $this;
  return BoundsBuilder__plus_impl_cz7f7x(BoundsBuilder__plus_impl_cz7f7x($this, rect.q2e()), rect.s2e());
}
function BoundsBuilder__plus_impl_cz7f7x_1($this, p) {
  var bb = $this;
  var inductionVariable = 0;
  var last = p.e1();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      bb = BoundsBuilder__plus_impl_cz7f7x(bb, p.d1(n));
    }
     while (inductionVariable < last);
  return bb;
}
function BoundsBuilder__plus_impl_cz7f7x_2($this, rects) {
  var bb = $this;
  var _iterator__ex2g4s = rects.a1();
  while (_iterator__ex2g4s.b1()) {
    var it = _iterator__ex2g4s.c1();
    bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, it);
  }
  return bb;
}
function BoundsBuilder__boundsOrNull_impl_se9lyg($this) {
  return _BoundsBuilder___get_isEmpty__impl__e9t785($this) ? null : _BoundsBuilder___get_bounds__impl__s1l1gx($this);
}
function BoundsBuilder__toString_impl_fmvxh7($this) {
  return 'BoundsBuilder(bounds=' + $this.toString() + ')';
}
function BoundsBuilder__hashCode_impl_649zbo($this) {
  return $this.hashCode();
}
function BoundsBuilder__equals_impl_jngfjs($this, other) {
  if (!(other instanceof BoundsBuilder))
    return false;
  var tmp0_other_with_cast = other instanceof BoundsBuilder ? other.u2e_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  if (Companion_instance_5 === VOID)
    new Companion_5();
  return Companion_instance_5;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  if (Companion_instance_6 === VOID)
    new Companion_6();
  return Companion_instance_6;
}
var MatrixType_IDENTITY_instance;
var MatrixType_TRANSLATE_instance;
var MatrixType_SCALE_instance;
var MatrixType_SCALE_TRANSLATE_instance;
var MatrixType_COMPLEX_instance;
var MatrixType_entriesInitialized;
function MatrixType_initEntries() {
  if (MatrixType_entriesInitialized)
    return Unit_instance;
  MatrixType_entriesInitialized = true;
  MatrixType_IDENTITY_instance = new MatrixType('IDENTITY', 0, 1, false, false, false);
  MatrixType_TRANSLATE_instance = new MatrixType('TRANSLATE', 1, 2, false, false, true);
  MatrixType_SCALE_instance = new MatrixType('SCALE', 2, 3, false, true, false);
  MatrixType_SCALE_TRANSLATE_instance = new MatrixType('SCALE_TRANSLATE', 3, 4, false, true, true);
  MatrixType_COMPLEX_instance = new MatrixType('COMPLEX', 4, 5, true, true, true);
}
var Companion_instance_7;
function Companion_getInstance_7() {
  if (Companion_instance_7 === VOID)
    new Companion_7();
  return Companion_instance_7;
}
function MatrixType_IDENTITY_getInstance() {
  MatrixType_initEntries();
  return MatrixType_IDENTITY_instance;
}
function MatrixType_TRANSLATE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_TRANSLATE_instance;
}
function MatrixType_SCALE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_SCALE_instance;
}
function MatrixType_SCALE_TRANSLATE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_SCALE_TRANSLATE_instance;
}
function MatrixType_COMPLEX_getInstance() {
  MatrixType_initEntries();
  return MatrixType_COMPLEX_instance;
}
var Companion_instance_8;
function Companion_getInstance_8() {
  if (Companion_instance_8 === VOID)
    new Companion_8();
  return Companion_instance_8;
}
function ortho(_this__u8e3s4, rect, near, far) {
  near = near === VOID ? 0.0 : near;
  far = far === VOID ? 1.0 : far;
  return Companion_getInstance_8().v2k(rect.y2d(), rect.z2d(), rect.b2e(), rect.a2e(), near, far);
}
function scaled(_this__u8e3s4, scale) {
  return _this__u8e3s4.s2h(scale.z2k_1, scale.a2l_1);
}
function get_scale(_this__u8e3s4) {
  return Scale.b2l(_this__u8e3s4.t2i_1, _this__u8e3s4.u2i_1);
}
var Orientation_CLOCK_WISE_instance;
var Orientation_COUNTER_CLOCK_WISE_instance;
var Orientation_COLLINEAR_instance;
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
var Orientation_entriesInitialized;
function Orientation_initEntries() {
  if (Orientation_entriesInitialized)
    return Unit_instance;
  Orientation_entriesInitialized = true;
  Orientation_CLOCK_WISE_instance = new Orientation('CLOCK_WISE', 0, 1);
  Orientation_COUNTER_CLOCK_WISE_instance = new Orientation('COUNTER_CLOCK_WISE', 1, -1);
  Orientation_COLLINEAR_instance = new Orientation('COLLINEAR', 2, 0);
}
var Companion_instance_10;
function Companion_getInstance_10() {
  if (Companion_instance_10 === VOID)
    new Companion_10();
  return Companion_instance_10;
}
var Companion_instance_11;
function Companion_getInstance_11() {
  if (Companion_instance_11 === VOID)
    new Companion_11();
  return Companion_instance_11;
}
function outerCircle(_this__u8e3s4) {
  var centerX = _this__u8e3s4.c2m();
  var centerY = _this__u8e3s4.d2m();
  return new Circle(_this__u8e3s4.e2m(), Companion_getInstance_17().t2m(centerX, centerY, _this__u8e3s4.z2d(), _this__u8e3s4.a2e()));
}
var Companion_instance_12;
function Companion_getInstance_12() {
  return Companion_instance_12;
}
var Companion_instance_13;
function Companion_getInstance_13() {
  return Companion_instance_13;
}
var Companion_instance_14;
function Companion_getInstance_14() {
  if (Companion_instance_14 === VOID)
    new Companion_14();
  return Companion_instance_14;
}
function toVector2(_this__u8e3s4) {
  return Vector2D.q2f(_this__u8e3s4.z2k_1, _this__u8e3s4.a2l_1);
}
function ScaleMode$Companion$COVER$lambda(i, c) {
  return i.x2l(toVector2(c.m2n(i)).n2n());
}
function ScaleMode$Companion$SHOW_ALL$lambda(i, c) {
  return i.x2l(toVector2(c.m2n(i)).o2n());
}
function ScaleMode$Companion$EXACT$lambda(i, c) {
  return c;
}
function ScaleMode$Companion$NO_SCALE$lambda(i, c) {
  return i;
}
var Companion_instance_15;
function Companion_getInstance_15() {
  if (Companion_instance_15 === VOID)
    new Companion_15();
  return Companion_instance_15;
}
var Companion_instance_16;
function Companion_getInstance_16() {
  if (Companion_instance_16 === VOID)
    new Companion_16();
  return Companion_instance_16;
}
function toFloat(_this__u8e3s4) {
  return Size2D.q2l(_this__u8e3s4.b2o_1, _this__u8e3s4.c2o_1);
}
function toInt(_this__u8e3s4) {
  return SizeInt.d2o(numberToInt(_this__u8e3s4.m2e_1), numberToInt(_this__u8e3s4.n2e_1));
}
function toSize(_this__u8e3s4) {
  return Size2D.u2l(_this__u8e3s4.h2d_1, _this__u8e3s4.i2d_1);
}
function transformX(_this__u8e3s4, m) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (m.w2d()) {
      tmp$ret$0 = _this__u8e3s4;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.q2f(m.k2h(_this__u8e3s4.h2d_1, _this__u8e3s4.i2d_1), m.n2h(_this__u8e3s4.h2d_1, _this__u8e3s4.i2d_1));
  }
  return tmp$ret$0.h2d_1;
}
function transformY(_this__u8e3s4, m) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (m.w2d()) {
      tmp$ret$0 = _this__u8e3s4;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.q2f(m.k2h(_this__u8e3s4.h2d_1, _this__u8e3s4.i2d_1), m.n2h(_this__u8e3s4.h2d_1, _this__u8e3s4.i2d_1));
  }
  return tmp$ret$0.i2d_1;
}
function square($this, x) {
  return x * x;
}
var Companion_instance_17;
function Companion_getInstance_17() {
  if (Companion_instance_17 === VOID)
    new Companion_17();
  return Companion_instance_17;
}
function toInt_0(_this__u8e3s4) {
  return Vector2I.z2m(numberToInt(_this__u8e3s4.h2d_1), numberToInt(_this__u8e3s4.i2d_1));
}
var Companion_instance_18;
function Companion_getInstance_18() {
  if (Companion_instance_18 === VOID)
    new Companion_18();
  return Companion_instance_18;
}
var Companion_instance_19;
function Companion_getInstance_19() {
  if (Companion_instance_19 === VOID)
    new Companion_19();
  return Companion_instance_19;
}
var Companion_instance_20;
function Companion_getInstance_20() {
  if (Companion_instance_20 === VOID)
    new Companion_20();
  return Companion_instance_20;
}
function interpolate_1(_this__u8e3s4, l, r) {
  return Vector2D.q2f(interpolate_0(_this__u8e3s4, l.h2d_1, r.h2d_1), interpolate_0(_this__u8e3s4, l.i2d_1, r.i2d_1));
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(Anchor2D, 'Anchor2D');
initMetadataForCompanion(Companion_0);
protoOf(Angle).xz = isAlmostEquals$default;
initMetadataForClass(Angle, 'Angle', VOID, VOID, [Comparable, IsAlmostEquals]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(BoundsBuilder, 'BoundsBuilder');
initMetadataForCompanion(Companion_2);
initMetadataForClass(Circle, 'Circle');
initMetadataForClass(IPointList$Sublist$listIterator$1);
initMetadataForClass(Sublist, 'Sublist', VOID, VOID, [KtList]);
initMetadataForCompanion(Companion_3);
initMetadataForInterface(IDoubleVectorList, 'IDoubleVectorList', VOID, VOID, [IsAlmostEquals]);
initMetadataForInterface(IPointList, 'IPointList', VOID, VOID, [IDoubleVectorList, KtList]);
initMetadataForCompanion(Companion_4);
initMetadataForClass(Line2D, 'Line2D', Line2D.a2g);
initMetadataForCompanion(Companion_5);
initMetadataForClass(MarginInt, 'MarginInt');
initMetadataForCompanion(Companion_6);
protoOf(Matrix).xz = isAlmostEquals$default;
initMetadataForClass(Matrix, 'Matrix', VOID, VOID, [IsAlmostEquals]);
initMetadataForClass(MatrixType, 'MatrixType');
initMetadataForCompanion(Companion_7);
protoOf(MatrixTransform).xz = isAlmostEquals$default;
initMetadataForClass(MatrixTransform, 'MatrixTransform', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(Matrix4, 'Matrix4', Matrix4.a2k);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Orientation, 'Orientation');
initMetadataForCompanion(Companion_10);
initMetadataForClass(RectCorners, 'RectCorners');
initMetadataForCompanion(Companion_11);
protoOf(Rectangle).xz = isAlmostEquals$default;
initMetadataForClass(Rectangle, 'Rectangle', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_12);
initMetadataForClass(RectangleInt, 'RectangleInt', RectangleInt.a2n);
initMetadataForCompanion(Companion_13);
initMetadataForClass(RoundRectangle, 'RoundRectangle');
initMetadataForCompanion(Companion_14);
initMetadataForClass(Scale, 'Scale', Scale.i2n);
initMetadataForCompanion(Companion_15);
initMetadataForClass(ScaleMode, 'ScaleMode');
initMetadataForCompanion(Companion_16);
initMetadataForClass(Size2D, 'Size2D', Size2D.y2n);
initMetadataForClass(SizeInt, 'SizeInt', SizeInt.e2o);
initMetadataForCompanion(Companion_17);
protoOf(Vector2D).xz = isAlmostEquals$default;
initMetadataForClass(Vector2D, 'Vector2D', Vector2D.b2g, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_18);
initMetadataForClass(Vector4F, 'Vector4F');
initMetadataForCompanion(Companion_19);
initMetadataForClass(Vector3F, 'Vector3F');
initMetadataForCompanion(Companion_20);
initMetadataForClass(Vector2I, 'Vector2I', Vector2I.t2p);
//endregion
//region block: init
Companion_instance_2 = new Companion_2();
Companion_instance_3 = new Companion_3();
Companion_instance_9 = new Companion_9();
Companion_instance_12 = new Companion_12();
Companion_instance_13 = new Companion_13();
//endregion
//region block: exports
export {
  MatrixType_IDENTITY_getInstance as MatrixType_IDENTITY_getInstance26n3n49ggvwm4,
  _Angle___init__impl__g23q1m as _Angle___init__impl__g23q1m36yxttgnpy5tv,
  _Angle___get_absoluteValue__impl__4qoakv as _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle,
  Angle__compareTo_impl_a0hfds as Angle__compareTo_impl_a0hfds24obl4qqhxk1t,
  _Angle___get_cosine__impl__vprvmu as _Angle___get_cosine__impl__vprvmu3ab5uwcliuboq,
  Angle__cosine_impl_bgvzun as Angle__cosine_impl_bgvzun1b2925dagclby,
  _Angle___get_degrees__impl__qg56vw as _Angle___get_degrees__impl__qg56vw2n539uvc01e1n,
  Angle__div_impl_ut2btd as Angle__div_impl_ut2btd1qmy7ftoy1opp,
  Angle__div_impl_ut2btd_0 as Angle__div_impl_ut2btd19ndx9mxcgcss,
  Angle__hashCode_impl_szcndt as Angle__hashCode_impl_szcndtx0rhatnvuhb1,
  Angle__minus_impl_xeau7k as Angle__minus_impl_xeau7ko02ca30grn4a,
  _Angle___get_normalized__impl__9s30ys as _Angle___get_normalized__impl__9s30ys1q15xt9x23bx,
  Angle__plus_impl_26v37k as Angle__plus_impl_26v37karx983dsduoy,
  _Angle___get_radians__impl__n00yt5 as _Angle___get_radians__impl__n00yt518seywpfbf9fr,
  _Angle___get_ratio__impl__ap3on4 as _Angle___get_ratio__impl__ap3on435dv91f5cbp85,
  _Angle___get_sine__impl__15nmyi as _Angle___get_sine__impl__15nmyi39oh4tio4auz1,
  Angle__sine_impl_3l11xv as Angle__sine_impl_3l11xv3pgl8zzgp52i0,
  _Angle___get_tangent__impl__vushdy as _Angle___get_tangent__impl__vushdy2zy6w59e4l7qg,
  Angle__times_impl_v3s9y2_0 as Angle__times_impl_v3s9y21yznxo5bj1uj7,
  Angle__times_impl_v3s9y2 as Angle__times_impl_v3s9y220yjbrxc13c3b,
  Angle__umod_impl_4wilf7 as Angle__umod_impl_4wilf71vq5gai237g1r,
  Angle__unaryMinus_impl_7901fr as Angle__unaryMinus_impl_7901fruk5m76f5kg06,
  Angle__unaryPlus_impl_eyi5pl as Angle__unaryPlus_impl_eyi5plrfyn5fslhvdp,
  _BoundsBuilder___get_bounds__impl__s1l1gx as _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i,
  BoundsBuilder__boundsOrNull_impl_se9lyg as BoundsBuilder__boundsOrNull_impl_se9lyg1z0iqowyff423,
  BoundsBuilder__hashCode_impl_649zbo as BoundsBuilder__hashCode_impl_649zbo2cbmgnd4y2see,
  BoundsBuilder__plus_impl_cz7f7x as BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3,
  BoundsBuilder__plus_impl_cz7f7x_2 as BoundsBuilder__plus_impl_cz7f7xqnc8b6uzo82y,
  BoundsBuilder__plus_impl_cz7f7x_1 as BoundsBuilder__plus_impl_cz7f7xiu6sbkxslhhl,
  BoundsBuilder__plus_impl_cz7f7x_0 as BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm,
  BoundsBuilder__toString_impl_fmvxh7 as BoundsBuilder__toString_impl_fmvxh7qh65bafrb2p,
  _BoundsBuilder___get_xmax__impl__gsz0km as _BoundsBuilder___get_xmax__impl__gsz0km31n4zf6la54qa,
  _BoundsBuilder___get_xmin__impl__o2sib0 as _BoundsBuilder___get_xmin__impl__o2sib0fqg01yornfcx,
  BoundsBuilder__xminOr_impl_k3l1m2 as BoundsBuilder__xminOr_impl_k3l1m233j5xey4uzzri,
  _BoundsBuilder___get_ymax__impl__oia4uz as _BoundsBuilder___get_ymax__impl__oia4uz2kb33iwdnvg1r,
  _BoundsBuilder___get_ymin__impl__5n2e8j as _BoundsBuilder___get_ymin__impl__5n2e8j1x2fwruhjr6r5,
  Companion_getInstance as Companion_getInstanceeqp3ibr2vvu9,
  Companion_getInstance_0 as Companion_getInstance3rze5babd97ff,
  Companion_getInstance_1 as Companion_getInstance2yu48324co92b,
  Companion_getInstance_5 as Companion_getInstancenbeyvbsm21qs,
  Companion_getInstance_6 as Companion_getInstance1zxby1ngivg0d,
  Companion_getInstance_8 as Companion_getInstance3qti4zygy7usz,
  Companion_getInstance_10 as Companion_getInstance3lu3946d91kk8,
  Companion_getInstance_11 as Companion_getInstance1bdwtq6rroayu,
  Companion_instance_12 as Companion_instanceu31qrc8c1r0r,
  Companion_getInstance_15 as Companion_getInstance23o88a0u6ly94,
  Companion_getInstance_16 as Companion_getInstance1j5nd3fbu9uao,
  Companion_getInstance_17 as Companion_getInstancewdpvtc2ehxkt,
  Companion_getInstance_19 as Companion_getInstance1yq7a1f60lp2k,
  Anchor2D as Anchor2D3ucppq7m9n3z8,
  Angle_between as Angle_between72970e1vlen9,
  Angle as Angle2itorpob18n08,
  BoundsBuilder as BoundsBuilder162uwsje56mvu,
  Circle as Circle1sk1qi5ph1m23,
  isAlmostEquals_0 as isAlmostEquals2qd88bwpjj4z5,
  isNotEmpty as isNotEmptyrwyeygz7izwg,
  IDoubleVectorList as IDoubleVectorListoa05cse3he2p,
  containsAll as containsAll194lepx84fvib,
  indexOf as indexOf3tp8bzbv46hci,
  iterator as iterator1sm8hwbj0nmg8,
  listIterator as listIteratorrk3szyua4uzm,
  listIterator_0 as listIterator3ooh2yjav3kr9,
  subList as subList2funs4qwcrhhq,
  IPointList as IPointListz7raskb2mrxa,
  Line2D as Line2D2pf35pcx71ncp,
  MarginInt as MarginInt3jiec8xsxkfd,
  Matrix4 as Matrix43neeu8v4zk4i7,
  MatrixTransform as MatrixTransform1wlsrhxt7473v,
  Matrix as Matrix1p940sdz227jj,
  RectCorners as RectCorners2yrtl8r42p5bs,
  RectangleInt as RectangleInt3lmu13ytuf5lk,
  Rectangle as Rectangle3q03woyn9k8x1,
  RoundRectangle as RoundRectangle271svjyf7w51p,
  Scale as Scale2cm697xlulcp5,
  Size2D as Size2Dum5ayuyhhau7,
  SizeInt as SizeInte6w85oa6mz6v,
  Vector2D as Vector2D378fe5rov8fgw,
  Vector2I as Vector2I2k5512l4eeahb,
  Vector4F as Vector4F1clr35ctch8js,
  adjustFromUp as adjustFromUp1ak85cceintt4,
  get_degrees as get_degrees3czcd4ojw4i,
  get_degrees_0 as get_degrees1wvulgxbo1fy6,
  interpolateAngleDenormalized as interpolateAngleDenormalized1hkwzk523mo1c,
  ortho as orthow9c0o91bw54n,
  outerCircle as outerCircle30hn5vvbpz9gu,
  get_radians as get_radians391vbqqjsolq6,
  get_scale as get_scale17gmsnxnqj6j9,
  scaled as scaled2eehd42i2trq9,
  toFloat as toFloat3b315y36g90cd,
  toInt as toIntp2twe4onfbic,
  toInt_0 as toIntu0rc68akxu7a,
  transformX as transformX33nszy4vzqsfy,
  transformY as transformY3ktoxhxwkzwk1,
  interpolate_1 as interpolatewhd2sgxffql5,
};
//endregion
